<script>
import { Component, Vue } from 'vue-property-decorator'
/* eslint-disable */
import Header from '@/components/common/Header'
import Login from './login'
import QrCode from './Qrcode'
/* eslint-disable */
import { frontInitMenu } from '@/assets/js/fetch'

@Component
export default class Api extends Vue {
  render() {
    return (
      <section>
        <Header class="header-black">
          <div class="header-nav header-nav-api">
            <div class="by-newrank hidden-up" />
            <router-link tag="div" to="/" class="by-newrank hidden" />
            <Login class="hidden" />
          </div>
        </Header>
        <main class="api api-list">
          <div class="aside">
            <div class="aside-content">
              <div class="aside-scroll" ref="asideScroll">
                <div
                  class="hidden-up m-menu-arrow-left"
                  onClick={this.hiddenAside}
                >
                  <i class="el-icon-d-arrow-left" />
                </div>
                <el-menu
                  router
                  default-active={
                    this.$route.params.id ? this.$route.params.id : 'all'
                  }
                  class="api-list-nav"
                  default-openeds={this.defaultOpeneds}
                >
                  <el-menu-item
                    index="all"
                    route={{ path: '/list' }}
                    class="aside-el-menu aside-el-menu-all"
                  >
                    接口列表
                  </el-menu-item>
                  {this.menuList.map((item, index) => {
                    const oneChild = item.children
                    if (oneChild.length) {
                      return (
                        <el-submenu
                          class="aside-el-submenu-one"
                          index={item.id}
                        >
                          <template slot="title">
                            <span>{item.name}</span>
                          </template>
                          {oneChild.map((oneItem, i) => {
                            const twoChild = oneItem.children
                            if (twoChild.length) {
                              return (
                                <el-submenu
                                  class="aside-el-submenu-two"
                                  index={oneItem.id}
                                >
                                  <template slot="title">
                                    <span>{oneItem.name}</span>
                                  </template>
                                  {twoChild.map((twoItem, twoIndex) => {
                                    return (
                                      <el-menu-item
                                        class="aside-el-menu aside-el-menu-list"
                                        route={{
                                          path: '/list/detail/' + twoItem.id
                                        }}
                                        index={twoItem.id}
                                      >
                                        · {twoItem.name}
                                      </el-menu-item>
                                    )
                                  })}
                                </el-submenu>
                              )
                            }
                          })}
                        </el-submenu>
                      )
                    }
                  })}
                </el-menu>
              </div>
            </div>
          </div>
          <div class="api-view">
            <router-view />
          </div>
        </main>
      </section>
    )
  }
  menuList = []
  defaultOpeneds = []
  created() {
    frontInitMenu('frontInitMenu').then(res => {
      const menusLise = res.data.value.menus
      if (menusLise.length) {
        menusLise.forEach(item => {
          this.defaultOpeneds.push(item.id)
        })
        this.menuList = menusLise
      }
    })
  }
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('click', this.hiddenAside, false)
      document.querySelector('.aside') &&
        document.querySelector('.aside').addEventListener('click', function(e) {
          e.stopPropagation()
        })
    })
    this.$refs.asideScroll.style.maxHeight = window.innerHeight - 137 + 'px'
  }
  destroyed() {
    document.removeEventListener('click', this.hiddenAside, false)
  }
  hiddenAside() {
    const aside = document.querySelector('.aside')
    if (aside) {
      aside.style.display = 'none'
    }
  }
}
</script>

<style lang="postcss">
@import '../../assets/css/_pub.css';

.api {
  &-view {
    position: relative;
    &-qr {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
      width: 140px;
      text-align: center;
      font-size: 14px;
      color: #21a2f2;
    }
    &-qrcode {
      display: none;
    }
    &-qr:hover .api-view-qrcode {
      display: block;
    }
  }
  &-list {
    width: 1176px;
    margin: auto;
    display: flex;
    align-items: flex-start;
    padding-top: 100px;
    padding-bottom: 37px;
    &-tips {
      font-size: 12px;
      color: #999;
      margin-bottom: 40px;
    }
    &-nav {
      width: 250px;
      margin-right: 10px;
      background-color: var(--white);
      // padding: 17px 0 50px;
      border-right: 0;
    }
  }
}
.api-nav-dt {
  &:hover {
    background-image: none;
    color: #333;
  }
}
.api-view-qr{
  z-index: 999;
}
@media screen and (width >= 768px) {
  .hidden-up {
    display: none !important;
  }
  .aside {
    display: block !important;
    position: fixed;
  }
  .api-view {
    margin-left: 270px;
  }
  .api-view-qr {
    display: block;
  }
}

@media screen and (width <= 1440px) {
  .rightnav {
    display: none;
  }
}
@media screen and (width > 1440px) {
  .api-view-qr {
    display: none;
  }
}
@media screen and (width < 768px) {
  .api-view {
    width: 100vw;
  }
  .hidden {
    display: none !important;
  }
  .header-nav {
    width: 100% !important;
  }
  .by-newrank {
    width: 98px !important;
    height: 21px !important;
    margin-left: 15px;
  }
  .header-nav-api {
    height: 40px;
  }
  .aside {
    position: fixed;
    left: 0;
    top: 40px;
    bottom: 0;
    overflow-y: auto;
    display: none;
    z-index: 100;
    background-color: #151819;
    color: #fff;
    padding-top: 0px !important;
    -webkit-overflow-scrolling: touch;
    & .api-list-nav {
      background: transparent;
      & li {
        color: #fff !important;
        & .el-submenu__title {
          color: #fff !important;
        }
      }
    }
    & .el-menu {
      background: transparent !important;
    }
  }
  .api-list {
    width: 100vw;
  }
  .docs {
    padding: 20px 15px 30px !important;
    width: 100vw !important;
  }
  .docs-item {
    width: 100%;
  }
  .docs-body-analysis {
    width: 100%;
    overflow-x: auto;
    margin-left: 0 !important;
  }
  .docs-body-table {
    width: 800px;
  }
  .docs-code {
    width: 100%;
    margin: 0 !important;
    padding: 15px 0 0 12px !important;
  }
  .m-menu-arrow-left {
    position: absolute;
    height: 40px;
    right: 10px;
    display: flex;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
    // top: 18px;
    z-index: 10;
    & .el-icon-d-arrow-left {
      font-size: 16px;
    }
  }
  .api-nav-dt:hover {
    background-image: none !important;
    color: #fff !important;
  }
  .api-list-main {
    padding: 20px 15px !important;
  }
  .m-docs {
    height: 44px;
    position: fixed;
    top: 40px;
    left: 0;
    right: 0;
    background-color: var(--white);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #333;
    z-index: 99;
    &-menu {
      width: 14px;
      height: 12px;
      position: absolute;
      display: flex;
      flex-direction: column;
      left: 14px;
      justify-content: space-between;
      cursor: pointer;
      top: 0;
      bottom: 0;
      left: 15px;
      margin: auto;
      & span {
        width: 14px;
        height: 1px;
        background-color: #000;
      }
    }
  }
  .api-view-qr {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/Api.vue